
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ChevronLeft, Info } from "lucide-react";
import Navbar from "@/components/Navbar";
import { PluginTestingDashboard } from "@/components/wordpress/PluginTestingDashboard";
import { PluginConnectionStatus } from "@/components/wordpress/PluginConnectionStatus";
import { Card, CardContent } from "@/components/ui/card";
import { Alert, AlertTitle, AlertDescription } from "@/components/ui/alert";

export default function PluginTesting() {
  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar isLoggedIn={true} />
      
      <div className="container mx-auto py-10 px-4 max-w-4xl">
        <div className="mb-8">
          <Button variant="outline" asChild className="mb-4">
            <Link to="/wordpress-plugin">
              <ChevronLeft className="mr-2 h-4 w-4" />
              Back to WordPress Plugin
            </Link>
          </Button>
          
          <h1 className="text-3xl font-bold mb-2">Plugin Testing & Verification</h1>
          <p className="text-gray-500">
            Test and verify that your WordPress backup plugin is working correctly.
          </p>
        </div>
        
        <Alert className="mb-6">
          <Info className="h-4 w-4" />
          <AlertTitle>Testing Mode Active</AlertTitle>
          <AlertDescription>
            This page allows you to check if your WordPress plugin is correctly installed and functioning. 
            If you're seeing "backing up" issues, the diagnostics below will help identify what's wrong.
          </AlertDescription>
        </Alert>
        
        <div className="grid gap-6">
          <PluginConnectionStatus />
          <PluginTestingDashboard />
          
          <Card>
            <CardContent className="pt-6">
              <h3 className="text-lg font-semibold mb-4">Troubleshooting Common Issues</h3>
              
              <div className="space-y-4">
                <div>
                  <h4 className="text-base font-medium">Stuck at 0% Backup Progress</h4>
                  <ul className="list-disc pl-5 mt-2 space-y-1 text-sm">
                    <li>Check your PHP memory limit - try increasing to at least 256MB</li>
                    <li>Verify file permissions on WordPress folders (wp-content needs to be writable)</li>
                    <li>Check server PHP timeout settings - may need to be increased</li>
                    <li>Disable other backup plugins which may conflict</li>
                    <li>Try disabling other plugins temporarily to identify conflicts</li>
                  </ul>
                </div>
                
                <div>
                  <h4 className="text-base font-medium">Connection Issues</h4>
                  <ul className="list-disc pl-5 mt-2 space-y-1 text-sm">
                    <li>Verify API key and Site ID are entered correctly</li>
                    <li>Check that WordPress REST API is enabled</li>
                    <li>Make sure your server is not blocking external connections</li>
                    <li>Check firewall settings on your server</li>
                  </ul>
                </div>
                
                <div>
                  <h4 className="text-base font-medium">Plugin Not Appearing in WordPress</h4>
                  <ul className="list-disc pl-5 mt-2 space-y-1 text-sm">
                    <li>Re-download and install the plugin</li>
                    <li>Make sure the plugin is activated in WordPress</li>
                    <li>Check for WordPress minimum version requirements</li>
                  </ul>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
}
